export interface Article {
  id: string;
  kind: 'hanzi' | 'plot';
  title: string;
  summary: string;
  cover: string;
  movieId: string;
  movieTitle: string;
  keyword: string;
  date: string;
  category: string;
}

export const articles: Article[] = [
  {
    id: 'a001',
    kind: 'hanzi',
    title: '「归」字何解：家书中的情感密码',
    summary: '从甲骨文到楷书，「归」字在《青川旧梦》里被反复特写，一笔一画皆是思念与身份的确认。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20calligraphy%20character%20in%20ink%20on%20aged%20paper%20with%20soft%20warm%20light%2C%20close%20up%20cultural%20detail&width=800&height=600&seq=article-hanzi-001&orientation=landscape',
    movieId: 'm001',
    movieTitle: '青川旧梦',
    keyword: '归',
    date: '2026-09-28',
    category: '家书文化',
  },
  {
    id: 'a002',
    kind: 'hanzi',
    title: '「裳」与「衣」：一字之差见等级',
    summary: '《霓裳羽衣》服饰考据严谨，从「衣」「裳」之别，读懂古代礼制与织造文明。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20silk%20garment%20detail%20with%20golden%20embroidery%20on%20deep%20navy%2C%20museum%20textile%20close%20up&width=800&height=600&seq=article-hanzi-002&orientation=landscape',
    movieId: 'm002',
    movieTitle: '霓裳羽衣',
    keyword: '裳',
    date: '2026-09-24',
    category: '服饰礼制',
  },
  {
    id: 'a003',
    kind: 'hanzi',
    title: '碑文拓印：金石气里的汉字之美',
    summary: '《碑文之下》用拓包拍打的声音，把碑刻汉字的质感从视觉延伸到听觉。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20stone%20inscription%20rubbing%20with%20black%20ink%20on%20paper%2C%20scholarly%20workshop%20detail&width=800&height=600&seq=article-hanzi-003&orientation=landscape',
    movieId: 'm003',
    movieTitle: '碑文之下',
    keyword: '碑',
    date: '2026-09-20',
    category: '金石碑刻',
  },
  {
    id: 'a004',
    kind: 'hanzi',
    title: '门匾暗号：坊市汉字里的江湖',
    summary: '《风起洛阳城》把全城门匾的首字连成暗语，汉字成了最精妙的解谜工具。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20shop%20plaque%20in%20night%20market%20with%20warm%20lantern%20glow%20against%20navy%20sky&width=800&height=600&seq=article-hanzi-004&orientation=landscape',
    movieId: 'm004',
    movieTitle: '风起洛阳城',
    keyword: '匾',
    date: '2026-09-15',
    category: '坊市文化',
  },
  {
    id: 'a005',
    kind: 'hanzi',
    title: '描红本：汉字启蒙里的耐心哲学',
    summary: '《描红》从传统启蒙方式切入，讲透笔顺与间架结构背后的秩序之美。',
    cover: 'https://readdy.ai/api/search-image?query=Child%20practicing%20Chinese%20calligraphy%20on%20a%20red%20copybook%2C%20warm%20afternoon%20light%2C%20nostalgic&width=800&height=600&seq=article-hanzi-005&orientation=landscape',
    movieId: 'm006',
    movieTitle: '描红',
    keyword: '笔顺',
    date: '2026-09-11',
    category: '书法启蒙',
  },
  {
    id: 'a006',
    kind: 'hanzi',
    title: '题跋：画中汉字的第二重叙事',
    summary: '《墨迹山河》里，题跋与印章如何补全一段被时间掩埋的历史。',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20ink%20scroll%20painting%20with%20calligraphy%20inscriptions%2C%20soft%20museum%20lighting&width=800&height=600&seq=article-hanzi-006&orientation=landscape',
    movieId: 'm005',
    movieTitle: '墨迹山河',
    keyword: '跋',
    date: '2026-09-06',
    category: '书画题跋',
  },
  {
    id: 'a007',
    kind: 'plot',
    title: '三段时间线如何织成《青川旧梦》',
    summary: '家书、身份与归来三个母题交错展开，梳理全剧最容易被忽略的叙事细节。',
    cover: 'https://readdy.ai/api/search-image?query=Misty%20blue%20mountains%20and%20a%20lone%20figure%20in%20ancient%20robe%2C%20cinematic%20ink%20painting%20mood&width=800&height=600&seq=article-plot-001&orientation=landscape',
    movieId: 'm001',
    movieTitle: '青川旧梦',
    keyword: '时间线',
    date: '2026-09-26',
    category: '剧情梳理',
  },
  {
    id: 'a008',
    kind: 'plot',
    title: '《霓裳羽衣》中那支失传的乐曲',
    summary: '一支乐曲串起盛世与倾覆，从开场到终章，看情节如何层层递进。',
    cover: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20court%20dancers%20in%20flowing%20silk%20with%20warm%20lantern%20light%20against%20navy&width=800&height=600&seq=article-plot-002&orientation=landscape',
    movieId: 'm002',
    movieTitle: '霓裳羽衣',
    keyword: '失传乐曲',
    date: '2026-09-22',
    category: '剧情梳理',
  },
  {
    id: 'a009',
    kind: 'plot',
    title: '《碑文之下》反转全解析：谁改写了历史',
    summary: '从破土到真相，逐章拆解这部考古悬疑片的层层反转。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20stone%20stele%20in%20a%20misty%20courtyard%2C%20solemn%20archaeological%20mood&width=800&height=600&seq=article-plot-003&orientation=landscape',
    movieId: 'm003',
    movieTitle: '碑文之下',
    keyword: '反转',
    date: '2026-09-18',
    category: '剧情梳理',
  },
  {
    id: 'a010',
    kind: 'plot',
    title: '《砚台迷局》推理结构：文房四宝即四把钥匙',
    summary: '笔、墨、纸、砚分别对应四段线索，拆解这套精巧的推理设计。',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20scholar%20stationery%20arrangement%20with%20candlelight%2C%20elegant%20mystery&width=800&height=600&seq=article-plot-004&orientation=landscape',
    movieId: 'm008',
    movieTitle: '砚台迷局',
    keyword: '推理',
    date: '2026-09-13',
    category: '剧情梳理',
  },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((article) => article.id === id);